import { VFC } from 'react';

import { faCommentDots } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const MessageBadge: VFC = () => {
  return (
    <div
      className="
        absolute -left-[5px] -top-[5px]
        flex h-6 w-6 items-center justify-center
        rounded-full border border-background-canvas
        bg-accent-default
        shadow-[0_0_1px_rgba(0,0,0,0.9),0_1px_3px_rgba(13,13,13,0.9)]
      "
    >
      <FontAwesomeIcon icon={faCommentDots} className="text-background-canvas" />
    </div>
  );
};
